// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { createAsyncAction } from 'typesafe-actions';

export interface SearchLabsKeywordRequestPayload {
  limit: number;
  name?: string;
}

export interface KeywordTitle {
  id: number;
  name: string;
}

export interface SearchLabsKeywordSuccessPayload {
  list: KeywordTitle[];
  count: number;
  name?: string;
}

export interface SearchLabsKeywordFailPayload {
  error: Error;
}

export const searchLabsKeywordActions = createAsyncAction(
  'elearning/SEARCH_LABS_Keyword_KEYWORD',
  'elearning/SEARCH_LABS_Keyword_KEYWORD_SUCCESS',
  'elearning/SEARCH_LABS_Keyword_KEYWORD_FAIL'
)<
  SearchLabsKeywordRequestPayload,
  SearchLabsKeywordSuccessPayload,
  SearchLabsKeywordFailPayload
>();
